@if (isMenu) {
  @if (showButton) {
    <button mat-menu-item [attr.aria-label]="'downloadEml' | translate">
      <div class="item-menu-center">
        <span class="material-symbols-outlined"> download_for_offline </span>
        <span>{{ 'downloadEml' | translate }}</span>
      </div>
    </button>
  }
} @else {
  <app-loading-icon-button
    label="downloadEml"
    classIcon="material-symbols-outlined"
    icon="download_for_offline"
    [showButton]="showButton"
    [showLoading]="showLoading"></app-loading-icon-button>
}
